import styled, { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
const disabledStyle = css `
  box-shadow: none;
  border: ${pxToRem(1)} dashed ${theme.semantic.border.strong};
  margin: ${pxToRem(1)}; /* /* prevents the input border from jumping */
`;
const defaultStyle = css `
  background-color: ${theme.semantic.surface.primary};
  border-color: ${theme.semantic.border.default};

  &:hover:not(:has(input:disabled)) {
    box-shadow: 0 0 0 ${pxToRem(1)} ${theme.semantic.border.default};
    border-color: ${theme.semantic.border.default};
  }

  &:has(input:focus-visible:not(:disabled)) {
    box-shadow: 0 0 0 ${pxToRem(1)} ${theme.swatches.warm[700]};
    border-color: ${theme.swatches.warm[700]};

    [data-icon='falcon'] {
      color: ${theme.semantic.foreground.primary};
    }
  }

  &:has(input:active:not(:disabled)) {
    box-shadow: 0 0 0 ${pxToRem(1)} ${theme.swatches.warm[1000]};
    border-color: ${theme.swatches.warm[1000]};
  }

  &:has(input:disabled) {
    ${disabledStyle};
  }
`;
const invalidStyle = css `
  background-color: ${theme.semantic.surface.primary};
  border-color: ${theme.semantic.text.danger};

  &:hover:not(:has(input:disabled)) {
    box-shadow: 0 0 0 ${pxToRem(1)} ${theme.semantic.text.danger};
    border-color: ${theme.semantic.text.danger};
  }

  &:has(input:focus-visible:not(:disabled)) {
    box-shadow: 0 0 0 ${pxToRem(1)} ${theme.semantic.text.danger};
    border-color: ${theme.semantic.text.danger};

    [data-icon='falcon'] {
      color: ${theme.semantic.text.danger};
    }
  }

  &:has(input:active:not(:disabled)) {
    box-shadow: 0 0 0 ${pxToRem(1)} ${theme.semantic.text.danger};
    border-color: ${theme.semantic.text.danger};
  }

  &:has(input:disabled) {
    ${disabledStyle};
  }
`;
const highlightStyle = css `
  background-color: ${theme.swatches.blue[50]};
  border-color: ${theme.swatches.blue[500]};

  &:hover:not(:has(input:disabled)) {
    box-shadow: 0 0 0 ${pxToRem(1)} ${theme.swatches.blue[500]};
    border-color: ${theme.swatches.blue[500]};
  }

  &:has(input:focus-visible:not(:disabled)) {
    box-shadow: 0 0 0 ${pxToRem(1)} ${theme.swatches.blue[500]};
    border-color: ${theme.swatches.blue[500]};

    [data-icon='falcon'] {
      color: ${theme.swatches.blue[500]};
    }
  }

  &:has(input:active:not(:disabled)) {
    box-shadow: 0 0 0 ${pxToRem(1)} ${theme.swatches.blue[500]};
    border-color: ${theme.swatches.blue[500]};
  }

  &:has(input:disabled) {
    ${disabledStyle};
  }
`;
const inputAppearance = (props) => {
    if (props.$invalid) {
        return invalidStyle;
    }
    switch (props.$appearance) {
        case 'highlight':
            return highlightStyle;
        default:
            return defaultStyle;
    }
};
export const Input = styled.input `
  border: none;
  background-color: transparent;
  flex: 1 1 100%;
  font-size: ${theme.fontSize.medium};
  line-height: ${theme.lineHeight.default};
  color: ${theme.semantic.foreground.primary};

  &:focus-visible {
    outline: none;
  }

  &:disabled {
    color: ${theme.swatches.warm[500]};
  }
`;
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.sm};
  position: relative;
  width: ${(props) => props.$stretch && '100%;'};
`;
export const Adornment = styled.div `
  display: flex;
`;
const descriptionInvalidStyles = css `
  color: ${theme.semantic.text.danger};
`;
export const Description = styled.div `
  font: ${theme.fontRole.caption};
  color: ${theme.semantic.foreground.primary};
  display: inline-block;
  margin-top: ${theme.spacing.sm};

  &:has(+ * input:disabled) {
    color: ${theme.swatches.warm[500]};
  }

  &:has(+ * input:focus-visible) {
    color: ${(props) => !props.$invalid && theme.semantic.foreground.primary};
  }

  ${(props) => props.$invalid && descriptionInvalidStyles};
`;
export const InputContainer = styled.div `
  box-sizing: border-box;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: ${theme.spacing.lg};
  padding: ${pxToRem(9)} ${pxToRem(16)};
  height: ${pxToRem(40)};
  line-height: ${pxToRem(40)};
  border: ${pxToRem(1)} solid transparent;
  border-radius: ${theme.borderRadius.md};
  white-space: nowrap;
  ${(props) => inputAppearance(props)};
  transition:
    box-shadow 0.25s ease-in-out,
    border-color 0.25s ease-in-out;
`;
